"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useCompetitionHomeData } from "../../../context/CompetitionHomeDataContext";
import { ArticleCarousel } from "../../../partials/articles/ArticleCarousel";
import { ArticleBentoGrid } from "../../../partials/articles/ArticleBentoGrid";
import { TeamLogosScroll } from "../../../partials/teams/TeamLogosScroll";
import { MatchCarousel } from "../../../partials/matches/MatchCarousel";
import { SeasonStatsCards } from "../../../partials/stats/SeasonStatsCards";
import { StandingsMini } from "../../../partials/standings/StandingsMini";
import { PromoSlot } from "@/features/promo-slots/PromoSlot";
import { AdSlot } from "@/features/ads/AdSlot";
import { LeadersTables } from "../../../partials/players/LeadersTables";
import { SectionStrip, type BrandedStyle } from "@/components/layout/SectionStrip";
import { HOME_HERO, HOME_MATCHES, HOME_TEAMS, HOME_ARTICLES, HOME_LEADERS } from "@/features/theme/sectionKeys";
import { SectionHeader } from "fansunited-sports-ui";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface FootballCompetitionHomeEditorialLayoutProps {
  videoShortsSlot?: React.ReactNode;
  videoHighlightsSlot?: React.ReactNode;
  sectionStyles?: Record<string, BrandedStyle>;
}
export function FootballCompetitionHomeEditorialLayout(t0) {
  const $ = _c(67);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    videoShortsSlot,
    videoHighlightsSlot,
    sectionStyles: t2
  } = t1;
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const sectionStyles = t3;
  const {
    latestNews,
    featuredPosts,
    promos,
    leaders,
    allTeams,
    allStageStandings,
    homeSlices,
    competitionStats,
    goalDistribution,
    hasCompetitionStats
  } = useCompetitionHomeData();
  const homeLabels = useLabels().homePage;
  const t4 = featuredPosts?.length ? featuredPosts : latestNews;
  let t5;
  if ($[4] !== t4) {
    t5 = t4.slice(0, 5);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const carouselArticles = t5;
  let t6;
  if ($[6] !== latestNews) {
    t6 = latestNews.slice(5, 13);
    $[6] = latestNews;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const gridArticles = t6;
  latestNews.slice(13, 19);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AdSlot id="content-top" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== homeSlices.lastFinished.length || $[10] !== homeSlices.nextUpcoming.length || $[11] !== sectionStyles) {
    t8 = homeSlices.lastFinished.length + homeSlices.nextUpcoming.length > 0 && <SectionStrip brandedStyle={sectionStyles?.[HOME_MATCHES]}><MatchCarousel cardStyles={{
        shadow: "none",
        hoverShadow: "sm",
        borderColor: "border-border"
      }} /></SectionStrip>;
    $[9] = homeSlices.lastFinished.length;
    $[10] = homeSlices.nextUpcoming.length;
    $[11] = sectionStyles;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== allStageStandings || $[14] !== carouselArticles || $[15] !== sectionStyles || $[16] !== videoShortsSlot) {
    t9 = carouselArticles.length > 0 && <SectionStrip brandedStyle={sectionStyles?.[HOME_HERO]}><div className="space-y-6"><div className="grid grid-cols-1 lg:grid-cols-4 gap-8"><div className="lg:col-span-3"><ArticleCarousel articles={carouselArticles} /></div><div className="hidden lg:block"><StandingsMini standings={allStageStandings} maxRows={11} /></div></div><div>{videoShortsSlot}</div></div></SectionStrip>;
    $[13] = allStageStandings;
    $[14] = carouselArticles;
    $[15] = sectionStyles;
    $[16] = videoShortsSlot;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = sectionStyles?.[HOME_TEAMS];
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      typography: {
        name: "text-lg md:text-2xl font-black uppercase tracking-wide text-foreground"
      }
    };
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== homeLabels.teams) {
    t12 = <SectionHeader entity={{
      name: homeLabels.teams,
      styles: t11
    }} />;
    $[19] = homeLabels.teams;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== allTeams || $[22] !== t12) {
    t13 = <div className="py-10"><TeamLogosScroll teams={allTeams} variant="cards" header={t12} /></div>;
    $[21] = allTeams;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13) {
    t14 = <SectionStrip brandedStyle={t10}>{t13}</SectionStrip>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <AdSlot id="mid-scroll-1" />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = sectionStyles?.[HOME_ARTICLES];
  let t17;
  if ($[28] !== gridArticles) {
    t17 = gridArticles.length > 0 && <><SectionHeader entity={{
        name: "Latest News",
        styles: {
          typography: {
            name: "text-lg md:text-2xl font-black uppercase tracking-wide text-primary-foreground mb-6"
          }
        }
      }} /><ArticleBentoGrid articles={gridArticles} layout="staggered" /></>;
    $[28] = gridArticles;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <SectionStrip brandedStyle={t16}>{t17}</SectionStrip>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <AdSlot id="mid-scroll-2" />;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const t20 = promos[0] ?? null;
  let t21;
  if ($[34] !== t20) {
    t21 = <PromoSlot row={t20} />;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = sectionStyles?.[HOME_LEADERS];
  let t23;
  if ($[36] !== leaders) {
    t23 = <LeadersTables leaders={leaders} />;
    $[36] = leaders;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t22 || $[39] !== t23) {
    t24 = <SectionStrip brandedStyle={t22}>{t23}</SectionStrip>;
    $[38] = t22;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <AdSlot id="mid-scroll-3" />;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = promos[2] ?? null;
  let t27;
  if ($[42] !== t26) {
    t27 = <PromoSlot row={t26} />;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== competitionStats || $[45] !== goalDistribution || $[46] !== hasCompetitionStats || $[47] !== homeSlices.teamWithMostWins) {
    t28 = hasCompetitionStats && <SeasonStatsCards competitionStats={competitionStats} goalDistribution={goalDistribution} teamWithMostWins={homeSlices.teamWithMostWins} />;
    $[44] = competitionStats;
    $[45] = goalDistribution;
    $[46] = hasCompetitionStats;
    $[47] = homeSlices.teamWithMostWins;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  const t29 = promos[1] ?? null;
  let t30;
  if ($[49] !== t29) {
    t30 = <PromoSlot row={t29} />;
    $[49] = t29;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <AdSlot id="content-bottom" />;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== t21 || $[53] !== t24 || $[54] !== t27 || $[55] !== t28 || $[56] !== t30 || $[57] !== videoHighlightsSlot) {
    t32 = <div className="space-y-8 mt-8">{t19}{videoHighlightsSlot}{t21}{t24}{t25}{t27}{t28}{t30}{t31}</div>;
    $[52] = t21;
    $[53] = t24;
    $[54] = t27;
    $[55] = t28;
    $[56] = t30;
    $[57] = videoHighlightsSlot;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t14 || $[60] !== t18 || $[61] !== t32 || $[62] !== t9) {
    t33 = <div className="mb-10">{t9}{t14}{t15}{t18}{t32}</div>;
    $[59] = t14;
    $[60] = t18;
    $[61] = t32;
    $[62] = t9;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== t33 || $[65] !== t8) {
    t34 = <div className="min-h-screen bg-background"><main className="max-w-350 mx-auto px-4 py-10 space-y-10">{t7}{t8}{t33}</main></div>;
    $[64] = t33;
    $[65] = t8;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  return t34;
}